<template>
  <div>
    <div>
      <h4>{{ $t('hubspot.jumpTo.description') }}</h4>
    </div>
    <div :class="[$style.multipleJumpsWrapper]">
      <div
        v-for="(target, pageKey) in jumpToPageKeys"
        :key="pageKey"
        :class="$style['jumpStyling']"
      >
        <router-link v-if="isFrontendLink(pageKey)" :to="{ name: pageKey }" :target="target">
          <IconSelect
            :class="[$style.icon, $style.iconSizeLarge]"
            :icon="getIcon(pageKey)"
            :svg-props="{ 'stroke-width': 1 }"
            :height="58"
            :width="58"
          />
          <v-btn
            v-if="getTranslation(pageKey, 'title')"
            class="btn"
            dense
            rounded
            elevation="0"
            color="primary"
            >{{ getTranslation(pageKey, 'title') }}</v-btn
          >
        </router-link>

        <a v-else :href="getTranslation(pageKey, 'routeName')" color="white" :target="target">
          <IconSelect
            :class="[$style.icon, $style.iconSizeLarge]"
            :icon="getIcon(pageKey)"
            :svg-props="{ 'stroke-width': 1 }"
            :height="58"
            :width="58"
          />
          <v-btn
            v-if="getTranslation(pageKey, 'title')"
            class="btn"
            dense
            rounded
            elevation="0"
            color="primary"
            >{{ getTranslation(pageKey, 'title') }}</v-btn
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import router from '@/js/plugins/router'
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'
import { HUBSPOT_JUMPTO_ICONS } from '@/js/components/HubSpot/Helpers/hubspot-constants.js'

export default {
  name: 'JumpToExternalForm',
  components: { IconSelect },
  props: {
    jumpToPageKeys: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(STORE_MODULES.APP, {
      appConfig: APP_GETTERS.APP_CONFIG,
    }),
    availableLinks() {
      return this.appConfig.links
    },
  },
  methods: {
    getTranslation(pageKey, translationKey) {
      if (this.queriedPageInLinks(pageKey) && translationKey == 'routeName') {
        return this.availableLinks[pageKey]
      } else {
        return this.$t('hubspot.jumpTo.' + `${pageKey}` + '.' + translationKey)
      }
    },
    getIcon(iconKey) {
      return HUBSPOT_JUMPTO_ICONS[iconKey] ?? ''
    },
    queriedPageInLinks(pageKey) {
      return Object.prototype.hasOwnProperty.call(this.availableLinks, pageKey)
    },
    isFrontendLink(pageKey) {
      return router.resolve({ name: pageKey }).route.matched.length
    },
  },
}
</script>
<style lang="scss" module>
.icon {
  color: var(--grey);
}

.jumpStyling {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    width: calc(25% - 0.75rem);
  }
  width: calc(50% - 0.5rem);
  padding: 1rem;

  border: var(--border-grey-lighten-1);

  transition: var(--transition-primary);

  &:hover {
    text-decoration: none;

    box-shadow: 0px 5px 15px 0 hsla(0, 0%, 0%, 0.15);
  }

  a {
    display: flex;
    flex-direction: column;
    grid-gap: 2rem 0;
    align-items: center;
  }
}

.multipleJumpsWrapper {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 1rem;
  margin-bottom: 4rem;
}
</style>
